import React from "react";

export default class FinishedExperimentScreen extends React.Component {
  render() {
    return (
      <div id="finished-experiment-container">
        <h1 className="finished-experiment-title">Phase Completed</h1>
        <h2 className="finished-experiment-section">
          Please continue to the next phase by using the "next" button at the
          bottom of your browser. If the next button is grayed out, please wait
          a few minutes and the button will enable. Thank you for your patience.
        </h2>
      </div>
    );
  }
}
